import _ from "lodash";
import { DatePicker, Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getSemesterMonths, getSemesters } from "../../api/semesters.api";
import useAxios from "../../hooks/useAxios";
import { IGetSemesterMonths, IGetSemesters, ISemester } from "../../models/semesters.model";
import Button from "../Button";
import MultiCampusModal from "./regular-test/modals/MultiCampusModal";
import useNotification from "../../hooks/useNotification";
import useUtil from "../../hooks/useUtil";
import { ISalesStatsParams } from "../../models/payments.model";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import EduStepSelect from "../common/EduStepSelect";
import Loader from "../Loader";
import ErrorResponse from "../ErrorResponse";
import SelectCampusMultiChoice from "../SelectCampusMultiChoice";
import moment from "moment";
import StatDatePickerTable from "./DatePickerTable";
import { DateTableType } from "../../constans";

interface IProps {
  onSearch: (
    req: ISalesStatsParams,
    prevReq?: ISalesStatsParams,
  ) => void;
}

const SalesSearch: FC<IProps> = ({
  onSearch,
}) => {
  const { t } = useTranslation();
  const { infoNotification } = useNotification();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0005 = 연도
  const SY0005 = commonCodes.find(
    (item) => item.commonCode === 'SY0005',
  )?.detailCode;
  const _SY0005 = _.orderBy(SY0005, ['orderSeq'], ['desc']);
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find(
    (item) => item.commonCode === 'PR0002',
  )?.detailCode;
  const { data: res, isLoading, error, execute } = useAxios<IGetSemesters>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetSemesterMonths>();
  /*
  useLoader(
    isLoading || isLoading2,
    [error, error2],
  );
  */

  const [semesterCode, setSemesterCode] = useState<number>();
  const [monthSeq, setMonthSeq] = useState<number>();
  const [eduStepCode, setEduStepCode] = useState<string>("");
  const [campusCodes, setCampusCodes] = useState<string[]>([]);  
  const [multiCampusVisible, setMultiCampusVisible] = useState(false);
  const [year, setYear] = useState('');
  const [semesterType, setSemesterType] = useState("");
  const [semesterData, setSemesterData] = useState<ISemester[]>([]);
  const [srtDate, setSrtDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [defSelType, setDefSelType] = useState<number>(0);

  useEffect(() => {
    execute(getSemesters());
  }, []);

  useEffect(() => {
    if (semesterCode) {
      execute2(getSemesterMonths(String(semesterCode)));
    }
  }, [semesterCode]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
    setSemesterCode(undefined);
  }, [year]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
    setSemesterCode(undefined);
  }, [semesterType]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
  }, [res]);

  /*
  const getPrevReq = (req: ISalesStatsParams) => {
    const prevReq: ISalesStatsParams = { ...req };

    if (req.monthSeq === 1) {
      const currentSemester = res?.data.find(item => item.semesterCode === req.semesterCode);
      if (!currentSemester) {
        return;
      }

      let prevSemester;
      if (currentSemester.semesterDiv === '01') {
        const prevYear = String(Number(currentSemester.learningYearCode) - 1);
        prevSemester = res?.data.find(item => item.learningYearCode === prevYear && item.semesterDiv === '04');
      } else {
        const prevSemesterDiv = `0${(Number(currentSemester.semesterDiv) - 1)}`;
        prevSemester = res?.data.find(item => item.learningYearCode === currentSemester.learningYearCode && item.semesterDiv === prevSemesterDiv);
      }

      if (!prevSemester) {
        return;
      }
      prevReq.semesterCode = prevSemester.semesterCode!;
      prevReq.monthSeq = 3;
    } else {
      prevReq.monthSeq = req.monthSeq - 1;
    }

    return prevReq;
  }
  */

  const onSubmit = () => {
    /*
    if (!semesterCode || !monthSeq) {
      return infoNotification(t('statistics.refund.message1'));
    }
    */

    // 학기, 기간 체크 예외 처리
    if (!semesterCode && !srtDate && !endDate) {
      return infoNotification(t('statistics.sales.msg2'));
    }

    // 시작일과 종료일의 차이가 1년을 넘지 않도록 체크
    if (srtDate && endDate) {
      const startDate = moment(srtDate, 'YYYYMMDD');
      const endDateTime = moment(endDate, 'YYYYMMDD');
      const diffInDays = endDateTime.diff(startDate, 'days');
      
      if (diffInDays > 365) {
        return infoNotification(t('statistics.placementTest.message5'));
      }
    }

    if (!semesterCode) {
      if (!srtDate) {
        return infoNotification(t('statistics.attendance.message1'));
      }
      if (!endDate) {
        return infoNotification(t('statistics.attendance.message2'));
      }
    } else if (!srtDate || !endDate) {
      if (!semesterCode) {
        return infoNotification(t('class.class.message4'));
      }
    }

    const req: ISalesStatsParams = {
      semesterCode: semesterCode || undefined,
      monthSeq: monthSeq || undefined,
      campusCodes: auth.hqYn === 'Y'
        ? campusCodes
        : (campusCodes.length ? campusCodes : auth.campus),
      srtDate: srtDate || undefined,
      endDate: endDate || undefined,
      semesterType: semesterType || undefined,
    }
    if (eduStepCode) {
      req.eduStepCode = eduStepCode;
    }
    //const prevReq = getPrevReq(req);

    onSearch(req); //onSearch(req, prevReq);
  };

  const fnSetSemesterData = (year : string, semesterType : string) => {
    if(res) {
      let data: ISemester[] = _.cloneDeep(res.data);

      if(year) {
        data = data.filter((item: any) => item.learningYearCode === year);
      }

      if(semesterType) {
        data = data.filter((item: any) => item.semesterType === semesterType);
      }

      setSemesterData(data);
    }
  }

  return (
    <>
    {isLoading && <Loader />}
    <ErrorResponse error={error} />

    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
            <SelectCampusMultiChoice
              placeholder={t('statistics.eLearning.title2')}
              onChange={setCampusCodes}
              value={campusCodes}
            />
            <label>
              ({campusCodes.length ? `${t('statistics.attendance.text2')}${campusCodes.length}${t('statistics.attendance.text1')}` : t('common.text.all')})
            </label>
          </li>
          <li>
            <label>
              {t('program.semester.column9')}
            </label>
            <Select
              className="w-120p"
              value={year}
              onChange={value => setYear(value)}
            >
              <Select.Option key={'all'} value={''}>
                {t('common.text.all')}
              </Select.Option>
              {
                _SY0005!.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>
          <li>
            <label>
              {t('program.semester.column11')}
            </label>
            <Select
              className="w-120p"
              value={semesterType}
              onChange={value => setSemesterType(value)}
            >
              <Select.Option key={'all'} value={''}>
                {t('common.text.all')}
              </Select.Option>
              {
                PR0002?.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>    
          <li>
            <label>{t('class.class.placeholder4')}</label>{/* 학기 */}
            <Select
              placeholder={t('statistics.regularTest.placeholder2')}
              value={semesterCode}
              onChange={value => {
                setSemesterCode(value)

                if(value) {
                  res?.data?.map(item => {
                    if(item.semesterCode === value) {
                      if(item.semesterType === 'SC') {
                        setMonthSeq(undefined);
                      }
                      setSrtDate('');
                      setEndDate('');
                    }
                  });
                } else {
                  setMonthSeq(undefined);
                }
              }}
            >
              <Select.Option value="">
                {t('common.text.all')}
              </Select.Option>
              {semesterData?.map(item => (
                <Select.Option
                  key={item.semesterCode}
                  value={item.semesterCode}
                >
                  {item.semesterName}
                </Select.Option>
              ))}
            </Select>
          </li>
          <li>
            <label>{t('student.student.column48')}</label>  {/* 월 */}
            <Select
              placeholder={t('statistics.regularTest.placeholder2')}
              value={monthSeq}
              onChange={value => setMonthSeq(value)}
              disabled={!semesterCode}
            >
              {res2?.data?.map(item => (
                <Select.Option
                  key={item.monthSeq}
                  value={item.monthSeq}
                >
                  {item.monthName}{t('statistics.refund.option1')}
                </Select.Option>
              ))}
            </Select>
          </li>          
          <li>
            <label>{t('common.placeholder.1')}</label> {/* 교육단계 */}
            <EduStepSelect
              eduStepCode={eduStepCode}
              setEduStepCode={setEduStepCode}
              width={90}
              includeAll
            />
          </li>
          <li className="period">
            <label>{t('sms.list.column1')}</label> {/* 기간 */}
            <div className="d-flex flex-column">  
              <div className="d-flex align-items-center">
                <div className="date-picker__area">
                  <DatePicker
                    value={srtDate ? moment(srtDate) : undefined}
                    onChange={e => {
                      if (e === null) setSrtDate('');
                      else setSrtDate(moment(e).format('YYYYMMDD'))
                    }}
                    format={['YYYY-MM-DD', 'YYYYMMDD']}
                  />
                  ~
                  <DatePicker
                    value={endDate ? moment(endDate) : undefined}
                    onChange={e => {
                      if (e === null) setEndDate('');
                      else setEndDate(moment(e).format('YYYYMMDD'))
                    }}
                    format={['YYYY-MM-DD', 'YYYYMMDD']}
                  />
                </div>
              </div>
              <div className="comm-btn__area mt-2">
                <StatDatePickerTable
                  setStartDate={setSrtDate}
                  setEndDate={setEndDate}
                  type={DateTableType.ALL}
                  defSelType={defSelType}
                  setDefSelType={setDefSelType}
                  setSemesterCode={undefined}
                />
              </div>
            </div>
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSubmit}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="flex flex-justify-center">
      {multiCampusVisible &&
        <MultiCampusModal
          visible={multiCampusVisible}
          setVisible={setMultiCampusVisible}
          campusCodes={campusCodes}
          setCampusCodes={setCampusCodes}
        />
      }      
    </div>
    </>
  );
}

export default SalesSearch;